// extracted by mini-css-extract-plugin
export default {"deletePopup":"Style_deletePopup__3O++f","deleteMessage":"Style_deleteMessage__4A10j","deleteGuestName":"Style_deleteGuestName__KvKeW","deleteButton":"Style_deleteButton__nGxpS"};